import { ofType } from 'redux-observable';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { ActionTypes } from '../utils/constants';
import { BaseApiService } from '../utils/BaseApiService';
import { fetchReservationSuccess, fetchReservationFailure, sendCotizacionSuccess } from '../actions';

export function reserve(action$: ActionsObservable) {
  return action$.pipe(
    ofType(ActionTypes.FETCH_RESERVATION_REQUEST),
    switchMap(action => {
      const { reservationId } = action.payload;
      return BaseApiService.get(
        `/api/cotizador/reserva/${reservationId}/`
      ).pipe(
        map(({ response: { data } }) => {
          return fetchReservationSuccess(data);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(fetchReservationFailure(), ...actions)
        )
      );
    })
  );
}


export function sendCotizacion(action$: ActionsObservable, store) {
  return action$.pipe(
    ofType(ActionTypes.SEND_COTIZACION_REQUEST),
    mergeMap(action => {
      const { tipo, modelo, version, anio, color, cotizacion } = action.payload;
      const payload = Object.keys(cotizacion).reduce((acc, curr) => {
        return {
          ...acc,
          [`reservation[${curr}]`]: cotizacion[curr]
        }
      }, {});
      return BaseApiService.post(
        `/api/cotizador/${tipo}/${modelo}/${version}/${anio}/${color}/resumen/${store.value?.categoria?.queryString}`,
        payload
      ).pipe(
        map(() => {
          return sendCotizacionSuccess();
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(sendCotizacionSuccess(), ...actions)
        )
      );
    })
  );
}